import axios from 'axios';
import store from '@/store';
import storage from '@/util/storage';

// Setup default
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['X-Authorization'] = process.env.VUE_APP_XAUTH;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Setup authorization
axios.defaults.headers.common.Authorization = `JWT ${
  storage.get('auth.accessToken')
  }`;

store.subscribe(({ type, payload }) => {
  if (type !== 'auth/SET_ACCESS_TOKEN') return;
  axios.defaults.headers.common.Authorization = `JWT ${payload}`;
});

let authTokenRequest;
const checkUser = {
  accessToken: null,
};

function resetAuthTokenRequest() {
  authTokenRequest = null;
}
// This function makes a call to get the auth token
// or it returns the same promise as an in-progress call to get the auth token
function getAuthToken() {
  if (!authTokenRequest) {
    authTokenRequest = store.dispatch('auth/getNewToken');
    authTokenRequest.then(resetAuthTokenRequest, resetAuthTokenRequest);
  }
  return authTokenRequest;
}

export default {
  install: (Vue) => {
    Vue.prototype.$axios = axios;
    Vue.prototype.$axios.interceptors.response.use(null, (error) => {

      if (error.response && error.response.status === 401 && error.response.data === 'Unauthorized' && (error.config.retried === undefined || error.config.retried === false)) {
        return getAuthToken().then((user) => {
          if (checkUser.accessToken !== user.accessToken) {
            store.dispatch('auth/saveNewToken', user);
          }
          checkUser.accessToken = user.accessToken;
          error.config.retried = true;
          error.config.headers.Authorization = `JWT ${user.accessToken}`;
          return axios(error.config);
        });
      }

      if (error) {
        const text =
          (error.response && error.response.data && error.response.data.errorLocalized)
            ? error.response.data.errorLocalized
            : 'Es ist ein Fehler aufgetreten';
        Vue.notify({
          title: 'Fehler',
          type: 'error',
          duration: 6000,
          text
        })
      }

      return Promise.reject(error);
    });
  },
};
